import { useMemo } from "react";
import { SeasonsClient } from "@/features/seasons/api/seasons-client";

export function useSeasonsClient() {
  return useMemo(() => new SeasonsClient(), []);
}
